import { render, staticRenderFns } from "./MarketingSiteGallery.vue?vue&type=template&id=bfdd20c0&scoped=true"
import script from "./MarketingSiteGallery.vue?vue&type=script&lang=js"
export * from "./MarketingSiteGallery.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteGallery.vue?vue&type=style&index=0&id=bfdd20c0&prod&lang=scss&scoped=true"
import style1 from "./MarketingSiteGallery.vue?vue&type=style&index=1&id=bfdd20c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd20c0",
  null
  
)

export default component.exports